import { MetricLabelTypeId as MetricLabelTypeId$1, make as make$1, isMetricLabel as isMetricLabel$1 } from '../../internal/metric/label.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricLabelTypeId = MetricLabelTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `MetricLabel` represents a key value pair that allows analyzing metrics at
 * an additional level of granularity.
 *
 * For example if a metric tracks the response time of a service labels could
 * be used to create separate versions that track response times for different
 * clients.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricLabel = isMetricLabel$1;

export { MetricLabelTypeId, isMetricLabel, make };
